import BaseDataInterpolator from './BaseDataInterpolator';

function DateInterpolator() {
    BaseDataInterpolator.call( this );

    this._threshold = 100;
}

DateInterpolator.prototype = Object.create( BaseDataInterpolator.prototype );

DateInterpolator.prototype.setReference = function() {
    this._primaryReference = 'performance';
    this._secondary = 'benchmark';
};

DateInterpolator.prototype.switchReference = function() {
    this._primaryReference = 'benchmark';
    this._secondary = 'performance';
};

DateInterpolator.prototype._passesThreshold = function( first, second ) {
    const firstRef = first[this._primaryReference],
        secondRef = second[this._primaryReference];

    return ( firstRef > this._threshold && secondRef < this._threshold ) ||
    ( firstRef < this._threshold && secondRef > this._threshold );
};

DateInterpolator.prototype._internalInterpolate = function( first, second ) {
    const firstRef = parseFloat( first[this._primaryReference] ),
        firstSecondary = parseFloat( first[this._secondary] ),
        secondRef = parseFloat( second[this._primaryReference] ),
        secondSecondary = parseFloat( second[this._secondary] );

    const denominator = secondRef - firstRef;

    if ( denominator === 0 ) { return null; }

    const additionalData = {
            date: null,
        },
        ratio = ( this._threshold - firstRef ) / denominator;
    additionalData[this._primaryReference] = this._threshold;

    const additionalDate = ( second.date.valueOf() - first.date.valueOf() ) * ratio + first.date.valueOf();

    additionalData.date = new Date( additionalDate );

    if ( firstSecondary && secondSecondary ) {
        additionalData[this._secondary] = ( secondSecondary - firstSecondary ) * ratio + firstSecondary;
    }

    return additionalData;
};

export default DateInterpolator;